import { injectBetData } from "@fresh8/ad-data-composition/src/betData";

export function useNoEvents(): void {
  const betData = injectBetData();
  const events = betData?.events.value;

  // No events for returned bet data
  if (events && events.value && Object.keys(events?.value).length === 0) {
    window.parent.postMessage({ type: "f8_no_events" }, "*");
  }
}
